<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="ack"><a id="page_ix"></a><a href="#/xhtml/contents#ack">Acknowledgments</a></p>
<p class="Bodyflush">This book has been a considerable number of years in the making, or rather on the back of John’s research shelf. It was in the mid-2000s that he was approached to contribute to the series, coming off the back of an intense eschatological interest that had generated a doctoral thesis and a number of publications on the account of hope provided by Karl Barth and George Steiner. A move to Australia resulted in this project being deferred continually. The more recent relocating to Melbourne has reignited possibilities for theological reflection, and the substantial addition of Dr. Scott Kirkland to the writing team has resulted in its completion. John would therefore very much like to thank the series editors, Profs. Alan Padgett and David Fergusson, as well as the publisher, William B. Eerdmans, for their very patient hope.</p>
<p class="Body">John would like to thank his father-in-law, Rev. John Carrick, for encouraging the early research interest in eschatological matters; Prof. Nicholas Lash for eruditely guiding the doctoral research; and Dr. Scott Kirkland for his invaluable aid in getting the project kicked off again and brought to a timely conclusion. John would finally like to give special thanks to his wife, Sandra, and children Archie, Jonathan, Joseph, Meg, and Robert. They have had to endure yet another work-life imbalanced year. Their hope is that the new year may bring something different.</p>
<p class="Body">Scott would like to thank Prof. John C. McDowell for bringing him onto this project, which has proven to be yet another opportunity to learn from John’s expertise as well as an occasion to enjoy thinking together. Scott would also like to thank his loving wife, Lisa, who continues to support his <a id="page_x">work beyond merit, and his mother, Joanna, who taught him to hope in the face of inexplicable loss.</a></p><a id="page_x">
<table cellpadding="0" cellspacing="0" class="Table1">
<colgroup>
<col width="70%"/>
<col width="30%"/>
</colgroup>
<tbody><tr>
<td class="tdleft">J<span class="small">OHN</span> C. M<span class="small">C</span>D<span class="small">OWELL</span> </td>
<td class="tdleft">S<span class="small">COTT</span> A. K<span class="small">IRKLAND</span></td>
</tr>
<tr>
<td class="tdleftb">Director of Research</td>
<td class="tdleftb">Trinity College</td>
</tr>
<tr>
<td class="tdleftb">University of Divinity</td>
<td class="tdleftb">University of Divinity</td>
</tr>
<tr>
<td class="tdleftb">Melbourne</td>
<td class="tdleftb">Melbourne</td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?72a128ae